<template>
  <v-container class="pt-0 pb-5">
    <v-row>
      <v-col>
        <div class="pa-2 rounded elevation-1 bg-white">



          <SportipsButton backButton chevronLeft>Retour</SportipsButton>




          <v-tabs class="mt-3" v-model="current_tab" color="primary-dark" centered>
            <v-tab value="tab-res">
              <v-icon>mdi-view-dashboard</v-icon>
              Résumé
            </v-tab>
            <v-tab value="tab-ins">
              <v-icon>mdi-run</v-icon>
              Informations
            </v-tab>

            <v-tab value="tab-opt" v-if="inscription.paye != '0'">
              <v-icon>mdi-pen-plus</v-icon>
              Options/activités
            </v-tab>

            <v-tab value="tab-ref" v-if="inscription.paye != '0'">
              <v-icon>mdi-cash-refund</v-icon>
              Remboursements
            </v-tab>
            <v-tab value="tab-pay" v-if="mainStore.authAdmin.isSportipsAdmin">
              <v-icon>mdi-cash</v-icon>
              Liens de paiement
            </v-tab>
            <v-tab value="tab-trans" v-if="mainStore.authAdmin.isSportipsAdmin || inscription.from_transfert != 1">
              <v-icon>mdi-swap-horizontal</v-icon>
              Transferer
            </v-tab>
            <v-tab value="tab-reassign" v-if="mainStore.authAdmin.hasSuperAdminRights">
              <v-icon>mdi-account-arrow-left-outline</v-icon>
              Réassigner
            </v-tab>
            <v-tab value="tab-act">
              <v-icon>mdi-gesture-tap</v-icon>
              Actions supplémentaires
            </v-tab>

          </v-tabs>

          <v-window v-model="current_tab">
            <v-window-item value="tab-res">
              <v-card>
                <v-card-text>
                  <DeleteInscription :id_inscription="inscription.id" @delete_inscription="onDeletedInscription"
                    v-if="inscription.paye != '0' && inscription.supprime != '1'">
                  </DeleteInscription>
                  <DeleteCommande :id_commande="inscription.id_commande" @delete_commande="onDeletedCommande"
                    v-if="inscription.paye == '0' && mainStore.module.has_preinscription || mainStore.module.some_races_have_preinscription || mainStore.module.preinscription_ended">
                  </DeleteCommande>
                  <ResumeInscription v-if="datas_loaded" :item="inscription"></ResumeInscription>
                </v-card-text>
              </v-card>
            </v-window-item>
            <v-window-item value="tab-ins">
              <v-card>
                <v-card-text>
                  <EditSelectionParcours
                    v-if="datas_loaded && inscription.list_courses && inscription.list_courses.list.length > 0"
                    :item="inscription" @updateSelectionCourse="regenerate_champs_formulaire"></EditSelectionParcours>
                  <div class="text-h6 mt-2 mb-4">Modifier l'inscription {{ inscription.prenom }} {{ inscription.nom }}
                  </div>
                  <EditInscription v-if="datas_loaded" :item="inscription" :key="onReloadChamps"></EditInscription>
                </v-card-text>
              </v-card>
            </v-window-item>
            <v-window-item value="tab-opt">
              <v-card>
                <v-card-text>
                  <EditSelectionOptions v-if="datas_loaded" :item="inscription"
                    @updateQuantiteOption="updateQuantiteOption" @updateQuantiteActivite="updateQuantiteActivite">
                  </EditSelectionOptions>
                </v-card-text>
              </v-card>
            </v-window-item>
            <v-window-item value="tab-ref">
              <v-card>
                <v-card-text>
                  <RefundInscription v-if="datas_loaded" :item="inscription"></RefundInscription>
                </v-card-text>
              </v-card>
            </v-window-item>
            <v-window-item value="tab-pay">
              <v-card>
                <v-card-text>
                  <PaymentLinkGenerator v-if="datas_loaded" :item="inscription"></PaymentLinkGenerator>
                </v-card-text>
              </v-card>
            </v-window-item>
            <v-window-item value="tab-trans">
              <v-card>
                <v-card-text>
                  <TransfertInscription v-if="datas_loaded" :item="inscription"></TransfertInscription>
                </v-card-text>
              </v-card>
            </v-window-item>
            <v-window-item value="tab-reassign">
              <v-card>
                <v-card-text>
                  <ReassignInscription v-if="datas_loaded" :item="inscription"></ReassignInscription>
                </v-card-text>
              </v-card>
            </v-window-item>
            <v-window-item value="tab-act">
              <v-card>
                <v-card-text>
                  <v-row class="d-flex justify-center">
                    <v-col md="6">
                      <div class="text-h6 mt-2 mb-4">Actions supplémentaires</div>
                      <div class="d-flex flex-column gap justify-start">
                        <label class="field_label">A quelle adresse mail renvoyer les mails ? (laisser vide pour envoyer
                          au participant)</label>
                        <v-text-field v-model="mail_adress"></v-text-field>
                      </div>
                      <div class="d-flex gap flex-wrap justify-start">
                        <v-btn color="primary-dark" @click="send_email_commande_client">Renvoyer le mail de
                          commande</v-btn>
                        <v-btn color="primary-dark" @click="send_email_client">Renvoyer le billet QR Code</v-btn>
                        <v-btn color="primary-dark" @click="send_email_inscription_client">Renvoyer le mail
                          d'inscription</v-btn>
                        <v-btn color="primary-dark" @click="send_email_rappel_doc">Renvoyer le mail de rappel de
                          documents</v-btn>
                      </div>
                      <div>
                        <v-alert class="mt-3" v-if="feedback_send_email != ''" border="start"
                          border-color="primary-dark" elevation="1">{{ feedback_send_email }}</v-alert>
                      </div>
                      <v-divider></v-divider>
                      <div class="d-flex flex-column gap justify-start mb-2">
                        <label class="field_label">Générer un lien de connexion à la fiche</label>
                        <v-btn color="primary-dark" @click="generate_connexion_link()" text>Copier dans le presse
                          papier</v-btn>
                      </div>
                      <div class="d-flex flex-column gap justify-start mb-2">
                        <label class="field_label">Générer un lien de connexion restreint aux documents</label>
                        <v-btn color="primary-dark" @click="generate_document_link()" text>Copier dans le presse
                          papier</v-btn>
                      </div>
                      <div class="d-flex flex-column gap justify-start mb-2">
                        <label class="field_label">Générer un lien de connexion restreint aux informations
                          d'inscription</label>
                        <v-btn color="primary-dark" @click="generate_infos_link()" text>Copier dans le presse
                          papier</v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-window-item>
          </v-window>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service";
import axios from "axios";
import EditSelectionParcours from "@/components/Administration/Edit_Inscriptions/EditSelectionParcours.vue";
import EditSelectionOptions from "@/components/Administration/Edit_Inscriptions/EditSelectionOptions.vue";
import DeleteInscription from "@/components/Administration/Edit_Inscriptions/DeleteInscription.vue";
import DeleteCommande from "@/components/Administration/Edit_Inscriptions/DeleteCommande.vue";
import ResumeInscription from "@/components/Administration/Edit_Inscriptions/ResumeInscription.vue";
import EditInscription from "@/components/Administration/Edit_Inscriptions/EditInscription.vue";
import RefundInscription from "@/components/Administration/Edit_Inscriptions/RefundInscription.vue";
import PaymentLinkGenerator from "@/components/Administration/Edit_Inscriptions/PaymentLinkGenerator.vue";
import TransfertInscription from "@/components/Administration/Edit_Inscriptions/TransfertInscription.vue";
import ReassignInscription from "@/components/Administration/Edit_Inscriptions/ReassignInscription.vue";
import Inscription from "@/classes/Fiche_Coureur/Inscription.class";
import List_Champs_Formulaire from "@/classes/Champs_Formulaire/List_Champs_Formulaire.class";


export default {
  components: {
    ResumeInscription,
    EditSelectionParcours,
    DeleteInscription,
    DeleteCommande,
    EditInscription,
    EditSelectionOptions,
    RefundInscription,
    TransfertInscription,
    ReassignInscription,
    PaymentLinkGenerator,

  },
  data() {
    return {
      current_tab: "tab-res",
      onReloadChamps: 0,
      list_champs_formulaires: {},
      inscription: {},
      datas_loaded: false,
      temp_coureur_champs: {},
      display_confirm_dialog_options: false,
      feedback_send_email: "",
      mail_adress: "",
    };
  },
  watch: {
    "$route.params.id_inscription": function () {
      this.$router.go();
    },
  },
  computed: {
    ...mapStores(useMainStore),
  },

  methods: {
    onDeletedInscription() {
      this.current_tab = "tab-res";
      this.$router.go();
    },
    onDeletedCommande() {
      this.current_tab = "tab-res";
      this.$router.go();
    },
    async generate_connexion_link() {
      let res = await axios.post("/administration/explorer/generate_connexion_link.php", { id_commande: this.inscription.id_commande });
      if (res.data.error) {
        console.log(res.data.error);
        return await false;
      } else {
        navigator.clipboard.writeText("https://sportips.fr/inscription/" + this.mainStore.module.base + "/fiche?auth=" + res.data.crypted_id);
        return await true;
      }
    },
    async generate_infos_link() {
      let response = await AdminService.encryptData(this.inscription.id);
      if (response) {
        navigator.clipboard.writeText("https://sportips.fr/inscription/" + this.mainStore.module.base + "/fiche/edit/" + this.inscription.id + "?token=" + response);
      }
    },
    async generate_document_link() {
      let response = await AdminService.encryptData(this.inscription.id);
      if (response) {
        navigator.clipboard.writeText("https://sportips.fr/inscription/" + this.mainStore.module.base + "/fiche/document/" + this.inscription.id + "?token=" + response);
      }
    },
    async send_email_client() {
      this.feedback_send_email = "";
      let res = await axios.post("/emails/send_j_minus_3.php", {
        id_inscription: this.inscription.id,
        mail: this.mail_adress,
      });
      if (res.data.error) {
        this.feedback_send_email = "Une erreur est survenue lors de l'envoi du mail.";
        console.log(res.data.error);
      } else {
        this.feedback_send_email = "Email d'inscription envoyé avec succès.";
      }
    },
    async send_email_inscription_client() {
      this.feedback_send_email = "";
      let res = await axios.post("/emails/send_inscription_email.php", {
        id_inscription: this.inscription.id,
        mail: this.mail_adress,
      });


      if (res.data.error) {
        this.feedback_send_email = "Une erreur est survenue lors de l'envoi du mail.";
        console.log(res.data.error);
      } else {
        this.feedback_send_email = "Email d'inscription envoyé avec succès.";
      }
    },

    async send_email_rappel_doc() {
      let res = await axios.post("/emails/send_rappel_document.php", {
        id_inscription: this.inscription.id,
        mail: this.mail_adress,
      });
      if (res.data.error) {
        this.feedback_send_email = "Une erreur est survenue lors de l'envoi du mail.";
        console.log(res.data.error);
      } else {
        this.feedback_send_email = "Email de rappel de document envoyé avec succès.";
      }
    },


    async send_email_commande_client() {
      this.feedback_send_email = "";
      let res = await axios.post("/commande/send_confirmation_email.php", {
        id_commande: this.inscription.id_commande,
        mail: this.mail_adress,
      });
      if (res.data.error) {
        this.feedback_send_email = "Une erreur est survenue lors de l'envoi du mail.";
        console.log(res.data.error);
      } else {
        this.feedback_send_email = "Email de commande envoyé avec succès.";
      }
    },

    updateQuantiteOption(list_options) {
      for (let i = 0; i < list_options.length; i++) {
        let found = false;
        for (let j = 0; j < this.inscription.commande_options.length; j++) {
          if (list_options[i].id == this.inscription.commande_options[j].id_item && this.inscription.commande_options[j].type == "option") {
            this.inscription.commande_options[j].quantite = list_options[i].quantite_souhaite;
            found = true;
          }
        }
        if (!found && list_options[i].quantite_souhaite > 0) {
          this.inscription.commande_options.push({
            id: "",
            type: "option",
            id_item: list_options[i].id,
            id_commande_inscription: this.inscription.id_commande_inscription,
            id_inscription: this.inscription.id,
            id_commande: this.inscription.id_commande,
            nom: list_options[i].nom,
            quantite: list_options[i].quantite_souhaite,
            prix: 0,
            valide: 1,
          });
        }
      }
    },
    updateQuantiteActivite(list_activites) {
      for (let i = 0; i < list_activites.length; i++) {
        let found = false;
        for (let j = 0; j < this.inscription.commande_options.length; j++) {
          if (list_activites[i].id == this.inscription.commande_options[j].id_item && this.inscription.commande_options[j].type == "activite") {
            this.inscription.commande_options[j].quantite = list_activites[i].quantite_souhaite;
            found = true;
          }
        }
        if (!found && list_activites[i].quantite_souhaite > 0) {
          this.inscription.commande_options.push({
            id: "",
            type: "activite",
            id_item: list_activites[i].id,
            id_commande_inscription: this.inscription.id_commande_inscription,
            id_inscription: this.inscription.id,
            id_commande: this.inscription.id_commande,
            nom: list_activites[i].nom,
            quantite: list_activites[i].quantite_souhaite,
            prix: 0,
            valide: 1,
          });
        }
      }
    },
    async generate_champs_formulaire() {
      this.list_champs_formulaires = new List_Champs_Formulaire();
      this.list_champs_formulaires.list_ids_parcours = [this.inscription.id_course];
      this.list_champs_formulaires.id_module = this.mainStore.module.id;
      await this.list_champs_formulaires.fetch();
      this.inscription.coureur.rebuild_list_champs(this.list_champs_formulaires.list);
      this.onReloadChamps++;
    },
    async regenerate_champs_formulaire() {
      this.inscription.dossard = "0";
      this.datas_loaded = false;
      this.inscription.coureur.champs = this.temp_coureur_champs;
      this.inscription.populate_coureur_infos_with_inscription();
      this.list_champs_formulaires = new List_Champs_Formulaire();
      this.list_champs_formulaires.list_ids_parcours = [this.inscription.id_course];
      this.list_champs_formulaires.id_module = this.mainStore.module.id;
      await this.list_champs_formulaires.fetch();
      this.inscription.coureur.rebuild_list_champs(this.list_champs_formulaires.list);

      this.onReloadChamps++;
      this.datas_loaded = true;
    },
  },

  async created() {


    this.inscription = new Inscription(this.mainStore.module.id);
    this.inscription.id = this.$route.params.id_inscription;
    await this.inscription.fetch("admin");
    await this.inscription.list_courses.fetch();
    this.temp_coureur_champs = JSON.parse(JSON.stringify(this.inscription.coureur.champs));
    this.inscription.set_selected_course();
    this.inscription.populate_coureur_infos_with_inscription();
    await this.generate_champs_formulaire();
    this.datas_loaded = true;

  },
};
</script>

<style lang="scss" scoped></style>